<script setup lang="ts">
import { nextTick, watch } from 'vue'
import { i18n } from '@/i18n'

export interface AlertDialogModel {
  visible: boolean
  title: string
  message: string
  accept?: () => void
  acceptLabel?: string
  rejectLabel?: string
}

const model = common.getAlertDialogModel()

watch(model, async (newVal) => {
  if (newVal.visible) {
    await nextTick()
    document.getElementById('dlgAlert')?.focus()
  }
})
</script>

<template>
  <Dialog id="dlgAlert" v-model:visible="model.visible" modal :header="model.title" class="w-auto lg:max-w-1/2 mx-5" @hide="model.accept?.()">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p class="font-medium mb-5 text-xl" v-html="model.message"></p>
    <div class="flex justify-center">
      <Button
        type="button"
        class="w-full"
        size="large"
        :label="model.acceptLabel ? model.acceptLabel : i18n.global.t('confirm.acceptLabel')"
        autofocus
        @click="
          () => {
            model.accept?.()
            model.visible = false
          }
        "></Button>
    </div>
  </Dialog>
</template>
